import { AccountSettingsProvider } from "./AccountSettingsProvider";

export function RemoteDataProviders({
  children,
}: {
  children: React.ReactNode;
}) {
  return <AccountSettingsProvider>{children}</AccountSettingsProvider>;
}
